import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import useTheme from '@material-ui/core/styles/useTheme';
import { useAppContext } from 'contexts/AppContext';
import { FsComponentSize } from 'globals/types';
import FsConversionChart from 'ui-elements/charts/FsConversionChart';
import FsPaper from 'ui-elements/main-elements/FsPaper';
import { purple } from 'globals/colors';
import FsMinWidthScrollBox from 'ui-elements/boxes/FsMinWidthScrollBox';
import { getPaperStyle } from './DashboardToggleChart.style';
import {
  ButtonsBox,
  ChartInnerBox,
  ChartWrapperBox,
  WrapperBox,
} from './DashboardToggleChart.style-elements';
import LargeToggleTabButton from './LargeToggleTabButton/LargeToggleTabButton';
import { getTabProps } from './DashboardToggleChart.utils';

const DashboardToggleChart: React.FC = () => {
  const theme = useTheme();
  const paperStyle = getPaperStyle(theme);
  const [activeId, setActiveId] = useState<number>(0);
  const {
    dashboardChars: { getTabs, getChart, init: initDashboardStore },
  } = useAppContext();
  const chartData = getChart(activeId);
  const isChartData = !!chartData.length;

  const tabProps = getTabProps({
    dataTabs: getTabs(),
    activeId,
    setActiveId,
  });

  useEffect(() => {
    initDashboardStore();
  }, [initDashboardStore]);

  return (
    <FsPaper
      withContentMargin={false}
      paddingSize={FsComponentSize.S}
      style={paperStyle}
      data-test="dashboard-toggle-chart"
    >
      <WrapperBox>
        <ButtonsBox>
          {tabProps.map(({ id, ...otherProps }) => (
            <LargeToggleTabButton {...{ ...otherProps, id }} key={id} />
          ))}
        </ButtonsBox>
        <FsMinWidthScrollBox breakpointDown="md" minWidth={700}>
          <ChartWrapperBox>
            <ChartInnerBox>
              {isChartData && (
                <FsConversionChart
                  chartData={getChart(activeId)}
                  data-test="conversion-chart"
                  mainColor={activeId ? purple.BRAND : undefined}
                />
              )}
            </ChartInnerBox>
          </ChartWrapperBox>
        </FsMinWidthScrollBox>
      </WrapperBox>
    </FsPaper>
  );
};

export default observer(DashboardToggleChart);
